import type { CSSObject } from '@emotion/react'
import { Spacing } from '@opallabs/gem'
import { modernWithFallback } from '@opallabs/lapidary'

export const container: CSSObject = {
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  paddingBlockStart: Spacing.M * 2.75,
}

export const content: CSSObject = {
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  inlineSize: Spacing.XL * 9.875,
  justifyContent: 'center',
  marginInlineEnd: 'auto',
  marginInlineStart: 'auto',
  ...modernWithFallback(
    [
      { maxInlineSize: `calc(100vi - ${Spacing.M}px)` },
      { maxInlineSize: `calc(100vw - ${Spacing.M}px)` },
    ],
    'width: 1vi'
  ),
}

export const fieldset: CSSObject = {
  border: 'none',
  display: 'flex',
  justifyContent: 'space-between',
  margin: 0,
  padding: 0,
}

export const footer: CSSObject = {
  marginBlockStart: Spacing.L * 1.5,
}

export const formTitle: CSSObject = {}
